import React from 'react';
import OtherUpdateForm from './components/form/OtherUpdateForm';
import AuthNavBar from './components/nav/AuthNav';

const OtherFieldMod = () => {
    return (
        <div>
            <AuthNavBar/>
            <OtherUpdateForm/>
        </div>
    )
    
}

export default OtherFieldMod